// @flow
import { withFormField } from "@fas/ui-core/lib/Form/FormContext";
import ListModalSetup from "../../components/ListModalSetup";

export default withFormField<*>(ListModalSetup);
